<mat-slide-toggle
  class="w-full"
  [checked]="user.enabled"
  (change)="actionSlideToggle()"
></mat-slide-toggle>
